import client from "./base";

const importDistributorInventory = async (ggSheetUrl: string) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/b2b/import-distributor-inv?ggSheetLink=${encodeURIComponent(
        ggSheetUrl
    )}`;

    return client.get(path).then((res) => res.data);
};
const b2bMvpApi = {
    importDistributorInventory,
};

export default b2bMvpApi;
